export default () => ({
  dialog: {
    width: '418px',
  },
  formGroupSelect: {
    marginBottom: '20px',
  },
  formNameInput: {
    marginBottom: '20px',
  },
});
